// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/NationalPark-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/RobotoFlex.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Arimo-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "RobotoFlex";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

/* Light Theme */
.light-theme {
  background-color: #eaecf0;
  font-family: "Arimo-Regular", sans-serif !important;
}

/* Dark Theme */
.dark-theme {
  background-color: #202020;
  font-family: "Arimo-Regular", sans-serif !important;
}

/* body {
  background-color: #eaecf0 !important;
  font-family: "RobotoFlex", sans-serif !important;
} */

body.dark-theme .navbar {
  background-color: #202020 !important;
}
body.light-theme .navbar {
  background-color: #eaecf0 !important;
}

body.dark-theme ::placeholder {
  color: #bbb !important;
  opacity: 1;
}

.theme-toggle .form-check-input {
  width: 36px;
  height: 18px;
  cursor: pointer;
}

.fixed-height-card {
  height: 300px;
}

body.light-theme .active-color {
  color: #b31e8d;
}

body.dark-theme .active-color {
  color: #fff;
}

.App-link {
  color: #61dafb;
}

.nav-icon-color {
  color: #000; /* or desired default */
  transition: 0.2s ease;
}
.nav-icon-color:hover {
  color: #263f86;
}

.bottom-nav-mobile a {
  font-size: 1.2rem;
  padding: 6px;
}
.bottom-nav-mobile i {
  display: block;
}

.mobile-nav-active {
  border-top: 2px solid #b31e8d; /* Bootstrap primary or any color */
  color: #b31e8d !important;
}

.status-active {
  background-color: #76d7c4;
  color: #282c34 !important;
}

.status-pending {
  background-color: #f9e79f;
  color: #282c34 !important;
}

.status-incomplete {
  background-color: #f5b7b1;
  color: #282c34 !important;
}

.appraisal-container {
  background-color: #f8f9fa;
  padding: 30px;
  border-radius: 10px;
}

body.light-theme .header-title {
  padding-bottom: 4px;
  color: #b31e8d;
}

body.dark-theme .header-title {
  padding-bottom: 4px;
  color: #ffffff;
}

.stepper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.step {
  width: 32px;
  height: 32px;
  border: 2px solid #d63384;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d63384;
  font-weight: 600;
  background-color: white;
}

.step-light {
  background-color: #fff;
  color: #B31E8D;
}

.step-dark {
  background-color: #2c2c2c;
  color: #fff;
  border-color: #fff;
}

.step.active {
  background-color: #d63384;
  color: white;
}

.line {
  width: 200px;
  height: 2px;
  background-color: #d63384;
}

.line-light {
  background-color: #d63384;
}

.line-dark {
  background-color: #666;
}

.dropdown-dark .dropdown-item {
  color: #fff;
  background-color: #2c2c2c;
}

.dropdown-dark .dropdown-item:hover,
.dropdown-dark .dropdown-item:focus {
  background-color: #444;
  color: #fff;
}

.custom-btn {
  min-width: 120px;
}

body.light-theme .login-container {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: "Arimo-Regular";
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

body.dark-theme .login-container {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  border: 1px solid #222121;
  border-radius: 8px;
  font-family: "Arimo-Regular";
  background-color: rgb(61, 61, 61);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

h2 {
  margin-bottom: 0.2rem;
}

p {
  margin-top: 0;
  font-size: 14px;
}

.dot-typing::after {
  content: '';
  display: inline-block;
  animation: dots 1.2s steps(3, end) infinite;
}

@keyframes dots {
  0% { content: ''; }
  33% { content: '.'; }
  66% { content: '..'; }
  100% { content: '...'; }
}


.login-form input[type="text"],
.login-form input[type="password"] {
  display: block;
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.checkbox-container input {
  margin-right: 8px;
}

.sign-in-button {
  width: 100%;
  padding: 12px;
  background-color: #b31e8d;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 12px;
}

.tracking-timeline {
  position: relative;
  margin-left: 15px;
  padding-left: 0;
}

.tracking-item {
  position: relative;
  padding-left: 30px;
  margin-bottom: 30px;
}

.tracking-item::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10px; /* center of the dot */
  width: 2px;
  background-color: #ccc;
  z-index: 0;
}

.icon-dot {
  position: absolute;
  left: 5px;
  top: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #28a745;
  z-index: 1;
}

.icon-dot.faded {
  background-color: #bbb;
}

.timestamp {
  font-size: 13px;
  margin-bottom: 3px;
}

.message {
  font-size: 14px;
  line-height: 1.4;
}

.readonly-textarea {
  background-color: #f8f9fa;
  cursor: not-allowed;
  color: #6c757d;
}

.signature-container {
  text-align: center;
  margin: 30px auto;
  max-width: 600px;
}

.signature-canvas {
  border: 2px solid #000;
  border-radius: 4px;
}

/* --------------------------------  */
@media (max-width: 768px) {
  .navbar-brand span {
    display: none;
  }

  .nav-link {
    padding: 0.5rem 0 !important;
  }

  .mobile-text-title {
    font-size: 14px;
  }

  .mobile-table-header {
    font-size: 12px;
  }

  .mobile-text {
    font-size: 12px;
  }

  .mobile-heading {
    width: 160px !important;
  }
}

@media (forced-colors: active) {
  .custom-radio-dot {
    background-color: Canvas !important;
    border: 2px solid ButtonText !important;
    outline: 2px solid ButtonText !important;
  }

  .custom-radio-dot.selected {
    background-color: Highlight !important;
  }

  .line {
    background-color: WindowText !important;
  }

  .circle-step {
    border: 2px solid WindowText !important;
    background-color: Window !important;
    color: WindowText !important;
  }

   img.signature-preview {
    forced-color-adjust: none; /* don't override by system */
    background-color: Window !important;
    border: 2px solid ButtonText !important;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,+DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAmD;EACnD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;;;GAGG;;AAEH;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW,EAAE,uBAAuB;EACpC,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B,EAAE,mCAAmC;EAClE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,iCAAiC;EACjC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,MAAM,YAAY,EAAE;EACpB,MAAM,aAAa,EAAE;EACrB,OAAO,cAAc,EAAE;AACzB;;;AAGA;;EAEE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU,EAAE,sBAAsB;EAClC,UAAU;EACV,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,uCAAuC;IACvC,wCAAwC;EAC1C;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,uCAAuC;IACvC,mCAAmC;IACnC,4BAA4B;EAC9B;;GAEC;IACC,yBAAyB,EAAE,6BAA6B;IACxD,mCAAmC;IACnC,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@font-face {\n  font-family: \"Arimo-Regular\";\n  src: url(\"fonts/NationalPark-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"RobotoFlex\";\n  src: url(\"fonts/RobotoFlex.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n/* Light Theme */\n.light-theme {\n  background-color: #eaecf0;\n  font-family: \"Arimo-Regular\", sans-serif !important;\n}\n\n/* Dark Theme */\n.dark-theme {\n  background-color: #202020;\n  font-family: \"Arimo-Regular\", sans-serif !important;\n}\n\n/* body {\n  background-color: #eaecf0 !important;\n  font-family: \"RobotoFlex\", sans-serif !important;\n} */\n\nbody.dark-theme .navbar {\n  background-color: #202020 !important;\n}\nbody.light-theme .navbar {\n  background-color: #eaecf0 !important;\n}\n\nbody.dark-theme ::placeholder {\n  color: #bbb !important;\n  opacity: 1;\n}\n\n.theme-toggle .form-check-input {\n  width: 36px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.fixed-height-card {\n  height: 300px;\n}\n\nbody.light-theme .active-color {\n  color: #b31e8d;\n}\n\nbody.dark-theme .active-color {\n  color: #fff;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.nav-icon-color {\n  color: #000; /* or desired default */\n  transition: 0.2s ease;\n}\n.nav-icon-color:hover {\n  color: #263f86;\n}\n\n.bottom-nav-mobile a {\n  font-size: 1.2rem;\n  padding: 6px;\n}\n.bottom-nav-mobile i {\n  display: block;\n}\n\n.mobile-nav-active {\n  border-top: 2px solid #b31e8d; /* Bootstrap primary or any color */\n  color: #b31e8d !important;\n}\n\n.status-active {\n  background-color: #76d7c4;\n  color: #282c34 !important;\n}\n\n.status-pending {\n  background-color: #f9e79f;\n  color: #282c34 !important;\n}\n\n.status-incomplete {\n  background-color: #f5b7b1;\n  color: #282c34 !important;\n}\n\n.appraisal-container {\n  background-color: #f8f9fa;\n  padding: 30px;\n  border-radius: 10px;\n}\n\nbody.light-theme .header-title {\n  padding-bottom: 4px;\n  color: #b31e8d;\n}\n\nbody.dark-theme .header-title {\n  padding-bottom: 4px;\n  color: #ffffff;\n}\n\n.stepper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.step {\n  width: 32px;\n  height: 32px;\n  border: 2px solid #d63384;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d63384;\n  font-weight: 600;\n  background-color: white;\n}\n\n.step-light {\n  background-color: #fff;\n  color: #B31E8D;\n}\n\n.step-dark {\n  background-color: #2c2c2c;\n  color: #fff;\n  border-color: #fff;\n}\n\n.step.active {\n  background-color: #d63384;\n  color: white;\n}\n\n.line {\n  width: 200px;\n  height: 2px;\n  background-color: #d63384;\n}\n\n.line-light {\n  background-color: #d63384;\n}\n\n.line-dark {\n  background-color: #666;\n}\n\n.dropdown-dark .dropdown-item {\n  color: #fff;\n  background-color: #2c2c2c;\n}\n\n.dropdown-dark .dropdown-item:hover,\n.dropdown-dark .dropdown-item:focus {\n  background-color: #444;\n  color: #fff;\n}\n\n.custom-btn {\n  min-width: 120px;\n}\n\nbody.light-theme .login-container {\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-family: \"Arimo-Regular\";\n  background-color: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\nbody.dark-theme .login-container {\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n  border: 1px solid #222121;\n  border-radius: 8px;\n  font-family: \"Arimo-Regular\";\n  background-color: rgb(61, 61, 61);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\nh2 {\n  margin-bottom: 0.2rem;\n}\n\np {\n  margin-top: 0;\n  font-size: 14px;\n}\n\n.dot-typing::after {\n  content: '';\n  display: inline-block;\n  animation: dots 1.2s steps(3, end) infinite;\n}\n\n@keyframes dots {\n  0% { content: ''; }\n  33% { content: '.'; }\n  66% { content: '..'; }\n  100% { content: '...'; }\n}\n\n\n.login-form input[type=\"text\"],\n.login-form input[type=\"password\"] {\n  display: block;\n  width: 100%;\n  padding: 12px;\n  margin-bottom: 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.checkbox-container input {\n  margin-right: 8px;\n}\n\n.sign-in-button {\n  width: 100%;\n  padding: 12px;\n  background-color: #b31e8d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  margin-bottom: 12px;\n}\n\n.tracking-timeline {\n  position: relative;\n  margin-left: 15px;\n  padding-left: 0;\n}\n\n.tracking-item {\n  position: relative;\n  padding-left: 30px;\n  margin-bottom: 30px;\n}\n\n.tracking-item::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 10px; /* center of the dot */\n  width: 2px;\n  background-color: #ccc;\n  z-index: 0;\n}\n\n.icon-dot {\n  position: absolute;\n  left: 5px;\n  top: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #28a745;\n  z-index: 1;\n}\n\n.icon-dot.faded {\n  background-color: #bbb;\n}\n\n.timestamp {\n  font-size: 13px;\n  margin-bottom: 3px;\n}\n\n.message {\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.readonly-textarea {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n  color: #6c757d;\n}\n\n.signature-container {\n  text-align: center;\n  margin: 30px auto;\n  max-width: 600px;\n}\n\n.signature-canvas {\n  border: 2px solid #000;\n  border-radius: 4px;\n}\n\n/* --------------------------------  */\n@media (max-width: 768px) {\n  .navbar-brand span {\n    display: none;\n  }\n\n  .nav-link {\n    padding: 0.5rem 0 !important;\n  }\n\n  .mobile-text-title {\n    font-size: 14px;\n  }\n\n  .mobile-table-header {\n    font-size: 12px;\n  }\n\n  .mobile-text {\n    font-size: 12px;\n  }\n\n  .mobile-heading {\n    width: 160px !important;\n  }\n}\n\n@media (forced-colors: active) {\n  .custom-radio-dot {\n    background-color: Canvas !important;\n    border: 2px solid ButtonText !important;\n    outline: 2px solid ButtonText !important;\n  }\n\n  .custom-radio-dot.selected {\n    background-color: Highlight !important;\n  }\n\n  .line {\n    background-color: WindowText !important;\n  }\n\n  .circle-step {\n    border: 2px solid WindowText !important;\n    background-color: Window !important;\n    color: WindowText !important;\n  }\n\n   img.signature-preview {\n    forced-color-adjust: none; /* don't override by system */\n    background-color: Window !important;\n    border: 2px solid ButtonText !important;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
